import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Typography from '@johnlewispartnership/wtr-ingredients/foundations/typography';

import styles from './Header.scss';

const BuilderHeader = ({ completed, completeIcon, defaultIcon, message, savings }) => (
  <header
    className={classNames(styles.builderHeader, { [styles.completed]: completed })}
    data-testid="builder-header"
  >
    {completed ? completeIcon : defaultIcon}
    <div>
      <Typography element="h2" styleAs="sectionHeading" noMargins fixedSize>
        {message}
      </Typography>
      {savings && (
        <Typography
          className={styles.savings}
          data-testid="savings"
          noMargins
          styleAs="paragraphHeading"
        >
          {savings}
        </Typography>
      )}
    </div>
  </header>
);

BuilderHeader.displayName = 'BuilderHeader';
BuilderHeader.propTypes = {
  completed: PropTypes.bool.isRequired,
  completeIcon: PropTypes.element.isRequired,
  defaultIcon: PropTypes.element.isRequired,
  message: PropTypes.string.isRequired,
  savings: PropTypes.string,
};
BuilderHeader.defaultProps = {
  savings: undefined,
};

export default BuilderHeader;
